var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEB\x9D\xBC\xEB\x94\x94\xEC\x98\xA4 \xEB\xB2\x84\xED\x8A\xBC=\xEA\xB8\xB0\xEB\xB3\xB8"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 256",
    cx: 10,
    cy: 10,
    r: 9.25,
    stroke: "#A9A9AE",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 257",
    cx: 10,
    cy: 10,
    r: 5,
    fill: "#A9A9AE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio);
export default __webpack_public_path__ + "static/media/radio.b910ae0267e32d4e58ca1f0c1000a843.svg";
export { ForwardRef as ReactComponent };